import { BlankContractProgressModel } from '@urbanx/agx.campaigns.client';
import {
  AgxPanel,
  AgxSpacer,
  AgxTypography,
  Icon_AlertCircleOutline,
} from '@urbanx/agx.ui-components2';
import CampaignOverviewInfoCard from './CampaignOverviewInfoCard';
import CampaignOverviewSection from './CampaignOverviewSection';

const BlankContractOverview = ({ progress }: { progress: BlankContractProgressModel }) => {
  const missingDetails = progress.details!.filter(({ complete }) => !complete);

  return (
    <AgxPanel
      id="campaign-overview-blank-contract"
      className="campaignOverviewGroup"
      bodyPadding="spacing-3xl"
    >
      <CampaignOverviewSection id="blank-contract" label="Blank contract">
        <CampaignOverviewInfoCard>
          {missingDetails.length ? (
            <AgxSpacer gap="spacing-md">
              <AgxSpacer
                direction="horizontal"
                contentAlignment="start"
                gap="spacing-sm"
                style={{ minWidth: 0 }}
              >
                <Icon_AlertCircleOutline
                  type="Danger"
                  width={18}
                  height={18}
                  color="var(--text-error)"
                />
                <AgxTypography id="blank-contract-missing-message" type="body_ui" size="medium">
                  <strong>Missing information:</strong> Complete these details before preparing the
                  blank contract
                </AgxTypography>
              </AgxSpacer>
              <ul
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 'var(--spacing-xs)',
                  margin: 0,
                  paddingLeft: 'var(--spacing-2xl)',
                }}
              >
                {missingDetails.map(({ label }, index) => (
                  <li key={label}>
                    <AgxTypography
                      id={`blank-contract-missing-${index}`}
                      type="body_ui"
                      size="medium"
                    >
                      {label!}
                    </AgxTypography>
                  </li>
                ))}
              </ul>
            </AgxSpacer>
          ) : (
            <AgxTypography
              id="blank-contract-not-prepared"
              type="body_ui"
              size="medium"
              color="var(--text-tertiary)"
            >
              The blank contract has not been prepared
            </AgxTypography>
          )}
        </CampaignOverviewInfoCard>
      </CampaignOverviewSection>
    </AgxPanel>
  );
};

export default BlankContractOverview;
